import * as React from "react";

const CubeClock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={51} height={55} viewBox="0 0 51 55">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M1 19.848C14.713 13.992 21.699 11.043 21.958 11c.441.122 20.811 8.19 20.959 8.455.11.293.11 8.634 0 25.024L22.183 53 1.361 44.84C1.121 28.276 1 19.945 1 19.849c0-.096 6.986 2.68 20.958 8.33l20.959-8.723M21.736 28v25"
                    stroke="#0071ad"
                    strokeWidth={2}
                />
                <g fillRule="nonzero">
                    <path
                        fill="#0071ad"
                        d="M36 0c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15z"
                    />
                    <path fill="#FFF" d="M36 28c-7.18 0-13-5.82-13-13S28.82 2 36 2s13 5.82 13 13-5.82 13-13 13z" />
                    <path
                        fill="#0071ad"
                        d="M40.704 17a1.41 1.41 0 01-.378-.051l-4.367-1.023c-.632-.175-.959-.395-.959-1.066V7.35c0-.819.559-1.35 1.358-1.35s1.048.77 1.048 1.591v6.419l3.298.85c.771.214 1.439.384 1.27 1.351-.122.693-.632.789-1.27.789z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(CubeClock);
